import { render, staticRenderFns } from "./FccBancos.vue?vue&type=template&id=79c5b878"
import script from "./FccBancos.vue?vue&type=script&lang=js"
export * from "./FccBancos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports